import React from 'react';
import DesktopGridItem from './DesktopGridItem';
import LazyLoad from 'react-lazyload';

export default function (props) {
  const gridItems = props.data.map((item, i) =>
    <div className={`c-${item.type} home-grid-item-wrapper`} key={`hp-grid-${item.image.id}-${i}i`}>
      <LazyLoad height='100%'>
        <DesktopGridItem itemData={item}/>
      </LazyLoad>
    </div>
  );
  return (
    <section id='image-grid-desktop'>
      {gridItems}
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/pages/home/desktop-grid/DesktopGrid.js